export default {
  layout: {
    patientBanner: {
      name: "Name",
      unknown: "Unknown",
      dateOfBirth: "Born",
      nhsNumber: "NHS no",
      age: "Age",
      address: "Address",
      postcode: "Postcode",
      gpPractice: "GP Practice",
      link: "Go to patient",
      edit: "Edit patient",
      merge: "Merge patient",
      undoMerge: "Undo Merge",
      reconcileTooltip: "Please add NHS number by clicking 'UNKNOWN'",
      dualMhaStatus: {
        existingLabel: "Existing MHA Status",
        coexistingLabel: "Coexisting MHA Status",
        warning:
          "Please be aware, this person may already be subject to the Act.",
      },
      raf: {
        dialogTitle: "Reasonable Adjustments",
        close: "Close",
        noRecordedNeed: "No current recorded need for adjustments to care",
        recordedAdjustments: "Recorded adjustments",
        impairments: "Impairments",
        underlyingConditions: "Underlying conditions",
        createdOn: "Created on:",
        lastUpdatedOn: "Last updated on:",
        added: "Added:",
        showMore: "Show more",
        showLess: "Show less",
        furtherGuidance: "Further guidance",
        guidance: {
          equalityAct: "Equality Act 2010: guidance",
          accessibleInformationStandard: "Accessible Information Standard",
        },
        // NHS spec mandates "<date> by <user's name> at <organisation name>".
        metadataLine: "{{date}} by {{user}} at {{org}}",
        indicator: {
          ariaLabel: "View reasonable adjustments",
          tooltipRecorded:
            "Reasonable adjustments recorded — click for detail",
          tooltipNone: "Reasonable adjustments — none recorded",
        },
      },
    },
    menu: {
      searchAndDropdownMenuLabel: "Team",
      openMenuLabel: "open drawer",
      profileLabel: "profile",
      changeContext: "(change)",
    },
    termsAndConditionsModal: {
      confirmationText: "By continuing, you agree to the <1>Terms of Use</1>.",
      confirmationTextTermsOfUse:
        "Please confirm you agree to the <1>Terms of Use</1>",
      acceptanceError:
        "Failed to accept terms and conditions - please contact support",
      acceptanceSuccess: "Terms and conditions successfully accepted",
    },
  },
};
